import i18n, { TOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { ILanguage } from "../interfaces/ILanguage";
import { sv } from "./locales/sv";
import { en } from "./locales/en";

i18n
  // detect the user's language (localStorage first, then browser settings)
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "sv",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      sv: {
        translation: sv,
      },
      en: {
        translation: en,
      },
    },
    detection: {
      // Check localStorage (the language switcher's persisted choice) before
      // falling back to the browser's language settings.
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;

type TranslationKey = keyof ILanguage;

export const t = (key: TranslationKey, options?: TOptions): string => {
  return i18n.t(key, options);
};
